module.exports = __webpack_public_path__ + "static/media/Krombacher-SansRegular.88353005.woff";